import type { GameId, PlayerPublic } from '@xox/shared'
import { readJson, writeJson } from '../lib/storage'
import { Segmented } from './ui'

const key = (game: GameId) => `${game}-cpu-human-first`

export function loadHumanFirst(game: GameId): boolean {
  return readJson<boolean>(key(game), false) === true
}

export function saveHumanFirst(game: GameId, v: boolean) {
  writeJson(key(game), v)
}

type Starter = 'cpu' | 'you'

/** Who opens against the bot. Sits on the dark boss card; remembered per device and game. */
export function BossStartPicker({
  bot,
  humanFirst,
  onChange,
  note,
}: {
  bot: PlayerPublic
  humanFirst: boolean
  onChange: (humanFirst: boolean) => void
  /** Shown under the switch while "You start" is on (a house rule, or a fair warning). */
  note?: string
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <Segmented<Starter>
        label="Who moves first"
        tone="dark"
        value={humanFirst ? 'you' : 'cpu'}
        onChange={(v) => onChange(v === 'you')}
        options={[
          { value: 'cpu', label: `${bot.nickname} starts` },
          { value: 'you', label: 'You start' },
        ]}
      />
      <p className="min-h-4 text-center text-xs text-white/70">{humanFirst && note ? note : ''}</p>
    </div>
  )
}
